import React, {useState, useRef, useEffect} from "react";
import {useDispatch} from "react-redux";
import * as userActions from "../../../../redux/User/actions";
import Select from 'react-select';
import {isNullOrEmptyArray} from "../../../../utils/general.js";
import Datatable from "../../../../components/Datatable/index";
import LoadingPanel from "../../../../components/LoadingPanel/index";
import columns from "./column.js";
import copy from 'copy-to-clipboard';
import Button from "../../../../components/Button/index";
import Toaster from "../../../../components/Toaster/index";
import useColumnFilters from "../../../../hooks/useColumnFilters.js";
import './CreateExternalUser.scss';

const CreateExternalUser = ({availableAccounts, onClose}) => {
	const [loading, setLoading] = useState(false);
	const [account, setAccount] = useState('');
	const [selectedUser, setselectedUser] = useState({displayName: 'john levi'});
	const [inviteUUID, setInviteUUID] = useState(null);
	const [contacts, setContacts] = useState(null);
	// const [filterResetKey, setFilterResetKey] = useState(false);
	const dispatch = useDispatch();
	const textRef = useRef();

	const {
		filters,
		sortBy,
		sortOrder,
		filteredData,
		handleFilterChange,
		resetWith,
		updateData,
		uniqueValuesByColumn,
		filterOrder
	} = useColumnFilters({
		data: contacts,
		columns,
		storageKey: `create-external-user`,
		initialState: {}
	});
	// useEffect(() => {
	// 	setFilterResetKey(true);
	// }, [search, selectedFilters]);

	// useEffect(() => {
	// 	if (filterResetKey) {
	// 		setFilterResetKey(false);
	// 	}
	// }, [filterResetKey]);
	useEffect(() => {
		updateData(contacts);
	}, [contacts]);

	const inviteUser = async (row) => {
		const user = {
			email: row.Email,
			displayName: row.FirstName + " " + row.LastName,
			account: account.value
		};

		setselectedUser(user);
		setLoading(true);
		dispatch(userActions.createExternalUser(user, userCreated));
	};

	const userCreated = (result) => {
		setLoading(false);
		setInviteUUID(result.uuid);
	};

	const onAccountChange = async accountName => {
		setAccount(accountName);
		setLoading(true);
		dispatch(userActions.loadContacts(accountName.value, contactsLoaded));
	};

	const contactsLoaded = (users) => {
		setContacts(users);
		setLoading(false);
	};

	const renderRegisterUser = (row) => {
		console.log("row",row.registered);

		if(row.registered) {
			return (
				<div style={{paddingLeft: '15px'}}>Registered</div>
			)
		}

		return (
			<Button center onClick={() => inviteUser(row)} type="blue">Create User</Button>
		)
	};

	const copyToClipboard = () => {
		const content = textRef.current?.innerText || "";
		copy(content);
		Toaster.showSuccess(`Copied!`);
	};

	const index = columns.findIndex(c => c.id === 'action');
	columns[index].cell = renderRegisterUser;

	if(inviteUUID) {
		// const url = `https://connact-internal-app.web.app/invite/${inviteUUID}`;

		return (
			<div className="invite-user-container">
				<div>
					<div style={{marginBottom: '5px'}}>Inviting <strong style={{color: '#365A64'}}>{selectedUser.displayName}</strong></div>
					<strong>{<a href={`mailto:${selectedUser.email}`}>{selectedUser.email}</a>}</strong>
				</div>

				<div contentEditable="true" ref={textRef} className="invite-user-email-content">
					Hi {selectedUser.displayName}!
					<br/><br/>
					You have been invited by Jonathan to join the CONNACT Manager platform!
					<br/><br/>
					CONNACT Manager allows you to establish a multi-cloud sales channel at top speed,  discover new business opportunities and automate outreach, deal-making, and tracking within your cloud partnerships.
					<br/><br/>
					Click on the following link to sign in:
					<br/>
					https://connact-internal-app.web.app/invite/{inviteUUID}
				</div>

				<div style={{display: 'flex', columnGap: '20px'}}>
					<Button center onClick={copyToClipboard} type="blue" width={200}>Copy to clipboard</Button>
					<Button center onClick={onClose} width={80}>Close</Button>
				</div>
			</div>
		)
	}

	return (
		<div className="create-user-container">

			{ loading && <LoadingPanel /> }

			<div className="create-user-fields">
				<div style={{width: '300px', textAlign: 'left'}}>
					<Select
						styles={{
							menuList: (provided, state) => ({
								...provided,
								maxHeight: '300px'
							}),
						}}
						value={account}
						onChange={onAccountChange}
						options={availableAccounts}
					/>
				</div>

				{
					!isNullOrEmptyArray(contacts) &&
				<Datatable 
					gridHeight="calc(100vh - 185px)"
					columns={columns}
					data={filteredData}
					//onSort={updateSort}
					sortBy={sortBy}
					sortOrder={sortOrder}
					filters={filters}
					onFilterChange={handleFilterChange}
					filterOrder={filterOrder}
					uniqueValuesByColumn={uniqueValuesByColumn}
					allData={contacts}
				/>
				}
			</div>
		</div>
	)
};

export default CreateExternalUser;
